import React, { useEffect, useState } from "react";
import { FaChevronDown, FaExclamationCircle } from "react-icons/fa";
import { ImSpinner } from "react-icons/im";
import PrivacyPolicyService from "../../../../services/PrivacyPolicy";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

function PrivacyPolicy() {
  const [policies, setPolicies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    getPolicies();
  }, []);

  const getPolicies = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await PrivacyPolicyService.getPolicyByUser({});
      if (res?.data?.success) {
        const list = res.data?.data?.filter((p) => !p.isDeleted) || [];
        setPolicies(list);
      } else {
        setError(res?.data?.en_message || "Failed to load policies.");
      }
    } catch (err) {
      console.error("Error fetching policies:", err);
      setError("Something went wrong while loading policies.");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleOpen = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 min-h-screen">
      <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate("/profile")}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
          >
            <FaArrowLeft className="text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-900">Privacy & Policy</h1>
          <div className="w-10"></div>
        </div>
      </header>

      <section className="px-6 pt-20">
        {isLoading && (
          <div className="flex flex-col items-center justify-center py-16 text-gray-500">
            <ImSpinner className="animate-spinCustom text-2xl mb-2" />
            <span>Loading policies...</span>
          </div>
        )}

        {!isLoading && error && (
          <div className="flex flex-col items-center justify-center py-16 text-red-500 text-center px-4">
            <FaExclamationCircle className="text-2xl mb-2" />
            <span>{error}</span>
          </div>
        )}

        {!isLoading && !error && policies.length === 0 && (
          <div className="text-center py-16 text-gray-400">
            No policies available.
          </div>
        )}

        {!isLoading && !error && policies.length > 0 && (
          <div className="space-y-3">
            {policies.map((policy) => {
              const isOpen = openId === policy._id;
              return (
                <div
                  key={policy._id}
                  className="bg-white rounded-2xl border border-gray-100 overflow-hidden"
                >
                  <button
                    onClick={() => toggleOpen(policy._id)}
                    className="w-full flex items-center justify-between p-4 text-left"
                  >
                    <p className="font-semibold text-gray-900">
                      {policy.title}
                    </p>
                    <FaChevronDown
                      className={`text-gray-400 transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-4 pb-4 text-sm text-gray-600 leading-relaxed whitespace-pre-wrap break-words">
                      {policy.descriptions}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}

export default PrivacyPolicy;
